module.exports = __webpack_public_path__ + "img/榆林东信二手车交易市场有限公司.b34c9139.jpg";